var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v(_vm._s(_vm.newValue)+" "),(_vm.change !== 0)?_c('span',[_vm._v(" ("),(_vm.change > 0)?_c('span',[_vm._v("+")]):_vm._e(),_vm._v(_vm._s(_vm.change)+") ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }